import { render, staticRenderFns } from "./display-field-array.vue?vue&type=template&id=2cbc3902&scoped=true&"
import script from "./display-field-array.ts?vue&type=script&lang=ts&"
export * from "./display-field-array.ts?vue&type=script&lang=ts&"
import style0 from "./display-field-array.scss?vue&type=style&index=0&id=2cbc3902&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbc3902",
  null
  
)

export default component.exports